import React from 'react'
import MaintenancePage from '../../Pages/maintainnance/MaintenancePage'

const LPU = () => {
  return (
    <>
    <MaintenancePage />
    </>
  )
}

export default LPU